import React, { useState } from "react";
import { Box, Button, TextField, Typography, Paper } from "@mui/material";
import PDFPreview from "./PDFPreview";

const PDFPreviewDemo = () => {
  const [googleDriveUrl, setGoogleDriveUrl] = useState(
    "https://drive.google.com/file/d/1Kdmb_JgeXfpc-Zg3WdxFexP9c"
  );
  const [showPreview, setShowPreview] = useState(false);

  const handlePreview = () => {
    if (googleDriveUrl) {
      setShowPreview(true);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ mb: 3 }}>
        PDF Preview จาก Google Drive
      </Typography>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          RequestID: 6505008902
        </Typography>
        
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            ลิงค์ Google Drive:
          </Typography>
          <TextField
            fullWidth
            value={googleDriveUrl}
            onChange={(e) => setGoogleDriveUrl(e.target.value)}
            placeholder="https://drive.google.com/file/d/..."
            size="small"
            sx={{ mb: 2 }}
          />
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="contained"
            onClick={handlePreview}
            disabled={!googleDriveUrl}
          >
            ดูตัวอย่าง PDF
          </Button>
          
          <Button
            variant="outlined"
            onClick={() => setShowPreview(false)}
          >
            ปิด
          </Button>
        </Box>
      </Paper>

      {showPreview && googleDriveUrl && (
        <Box sx={{ mt: 3 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            ตัวอย่าง PDF:
          </Typography>
          <PDFPreview
            googleDriveUrl={googleDriveUrl}
            height="700px"
            title="เอกสารแนบ"
            showFullscreenButton={true}
          />
        </Box>
      )}
    </Box>
  );
};

export default PDFPreviewDemo;
